export const ProjectData = [
    {
        title: "Sorting Visualizer",
        image: ["assets/sv1.png", "assets/sv2.png", "assets/sv3.png", "assets/sv4.png"],
        about: 'This website visualizes various sorting techniques like bubble sort, quick sort, insertion sort, selection sort, merge sort, and shell sort. Sorting animation speed can be changed while the array is sorted. You can generate arrays ranging from size 2 to 100 and randomize them. This site is also responsive.',
        languages: "HTML, CSS, JavaScript",
        github: "https://github.com/nitishgupta08/Sorting-Visualizer"
    },
    {
        title: "University Management System",
        image: ["assets/ums1.jpg", "assets/ums2.png", "assets/ums3.png", "assets/ums4.png"],
        about: 'This system has three types of users. Admin, teachers and students. The admin has the ability to add/update students and teachers and also view the total list. When a new student/teacher is added they automatically get a unique userID and password.',
        languages: "Java, MySQL",
        github: "https://github.com/nitishgupta08/University-Management-System"
    },
    {
        title: "Bank Management System",
        image: ["assets/bm2.png", "assets/bm2.png", "assets/bm3.png", "assets/bm4.png"],
        about: "This is a very simple bank management system. It has clean interface. When new user sign's up they automatically get an account number and password. The user can deposit, withdraw, get fast cash, get mini-statement, chane pin and check account balance",
        languages: "Java, MySQL",
        github: "https://github.com/nitishgupta08/Bank-Management-System"
    }
];